(() => {
  const mq = window.matchMedia('(max-width: 760px)');
  const qs = (s, r=document) => r.querySelector(s);
  const fireChange = el => el.dispatchEvent(new Event('change', {bubbles:true}));

  function init(){
    if (qs('.wards-sticky-buy')) return;
    const aerosolRoot = qs('.aerosol-v2');
    const form = aerosolRoot ? qs('.aerosol-v2__form', aerosolRoot) : qs('.product-form');
    if (!form) return;

    const originalAdd = aerosolRoot ? qs('[data-aerosol-add]', form) : qs('.add-to-cart-btn', form);
    const originalQty = qs('input[name="quantity"]', form);
    const variantSelect = qs('select[name="id"]', form);
    const colourGroup = aerosolRoot ? [...form.querySelectorAll('[data-option-position]')].find(g => /colou?r/i.test((qs('.aerosol-v2__option-title', g)||{}).textContent || '')) : null;
    if (!originalAdd) return;

    const bar = document.createElement('div');
    bar.className = 'wards-sticky-buy';
    bar.setAttribute('aria-label','Quick purchase controls');

    const optionField = document.createElement('div');
    optionField.className = 'wards-sticky-buy__field';
    const optionLabel = document.createElement('label');
    optionLabel.textContent = colourGroup ? 'Colour' : 'Colour / Option';
    const stickySelect = document.createElement('select');
    stickySelect.setAttribute('aria-label', optionLabel.textContent);
    optionField.append(optionLabel, stickySelect);

    let syncOption = () => {};
    if (colourGroup) {
      const buttons = [...colourGroup.querySelectorAll('[data-option-value]')];
      buttons.forEach(b => stickySelect.add(new Option(b.dataset.optionValue, b.dataset.optionValue)));
      syncOption = () => {
        const active = qs('.is-selected[data-option-value]', colourGroup);
        if (active) stickySelect.value = active.dataset.optionValue;
      };
      stickySelect.addEventListener('change', () => {
        const target = buttons.find(b => b.dataset.optionValue === stickySelect.value);
        if (target) target.click();
      });
      new MutationObserver(syncOption).observe(colourGroup,{subtree:true,attributes:true,attributeFilter:['class']});
    } else if (variantSelect) {
      [...variantSelect.options].forEach(o => stickySelect.add(new Option(o.text.replace(/\s*-\s*Sold out\s*$/i,''), o.value, false, o.selected)));
      syncOption = () => { stickySelect.value = variantSelect.value; };
      stickySelect.addEventListener('change', () => { variantSelect.value = stickySelect.value; fireChange(variantSelect); });
      variantSelect.addEventListener('change', syncOption);
    } else {
      optionField.style.display = 'none';
    }

    const qtyField = document.createElement('div');
    qtyField.className = 'wards-sticky-buy__field';
    const qtyLabel = document.createElement('label'); qtyLabel.textContent='Qty';
    const qtyWrap = document.createElement('div'); qtyWrap.className='wards-sticky-buy__qty-wrap';
    const minus = document.createElement('button'); minus.type='button'; minus.textContent='−'; minus.setAttribute('aria-label','Decrease quantity');
    const qty = document.createElement('input'); qty.type='number'; qty.min='1'; qty.step='1'; qty.value=originalQty ? originalQty.value || '1' : '1'; qty.setAttribute('aria-label','Quantity');
    const plus = document.createElement('button'); plus.type='button'; plus.textContent='+'; plus.setAttribute('aria-label','Increase quantity');
    qtyWrap.append(minus,qty,plus); qtyField.append(qtyLabel,qtyWrap);
    const syncQtyToOriginal = () => { if (originalQty) { originalQty.value = Math.max(1, parseInt(qty.value||'1',10)); fireChange(originalQty); } };
    qty.addEventListener('change', syncQtyToOriginal);
    minus.addEventListener('click',()=>{qty.value=Math.max(1,parseInt(qty.value||'1',10)-1);syncQtyToOriginal()});
    plus.addEventListener('click',()=>{qty.value=Math.max(1,parseInt(qty.value||'1',10)+1);syncQtyToOriginal()});
    if (originalQty) originalQty.addEventListener('change',()=>{qty.value=originalQty.value||'1'});

    const add = document.createElement('button');
    add.type='button'; add.className='wards-sticky-buy__add'; add.textContent='ADD TO CART';
    const syncAvailability = () => {
      add.disabled = !!originalAdd.disabled;
      add.textContent = originalAdd.disabled ? (originalAdd.dataset.soldLabel || 'SOLD OUT') : 'ADD TO CART';
    };
    add.addEventListener('click',()=>{ syncQtyToOriginal(); originalAdd.click(); });
    new MutationObserver(syncAvailability).observe(originalAdd,{attributes:true,attributeFilter:['disabled']});

    bar.append(optionField, qtyField, add);
    document.body.appendChild(bar);
    document.body.classList.add('wards-sticky-buy-active');
    syncOption(); syncQtyToOriginal(); syncAvailability();
    const applyMq=()=>{bar.hidden=!mq.matches;document.body.classList.toggle('wards-sticky-buy-active',mq.matches)};
    mq.addEventListener ? mq.addEventListener('change',applyMq) : mq.addListener(applyMq);
    applyMq();
  }
  document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',init) : init();
})();
